import React, { useEffect } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";

// layouts
import { MainLayout } from "layouts";

// components
import { Switch } from "components/form";

// redux
import {
  fetchNotificationSettings,
  updateNotificationSettings,
} from "redux/slices/user/userSlice";

const NotificationSettings = () => {
  const dispatch = useDispatch();
  const { notificationSettings } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(fetchNotificationSettings());
  }, []);

  const NOTIFICATION_SETTINGS_OPTIONS = [
    {
      value: notificationSettings.scheduleValue,
      label: "스케줄 알림",
      checked: notificationSettings.schedule,
      name: "schedule",
    },
    {
      value: notificationSettings.salesValue,
      label: "매출 알림",
      checked: notificationSettings.sales,
      name: "sales",
    },
    {
      value: notificationSettings.userValue,
      label: "회원 알림",
      checked: notificationSettings.user,
      name: "user",
    },
    {
      value: notificationSettings.coachValue,
      label: "임직원 알림",
      checked: notificationSettings.coach,
      name: "coach",
    },
    {
      value: notificationSettings.ceoReportValue,
      label: "CEO 리포트",
      checked: notificationSettings.ceoReport || false,
      name: "ceoReport",
    },
    {
      value: notificationSettings.smsValue,
      label: "SMS ∙ 공지",
      checked: notificationSettings.sms,
      name: "sms",
    },
  ];

  const handleChange = (e, name) => {
    console.log("e, name:", e, name);
    dispatch(
      updateNotificationSettings({
        name: name,
        value: e.target.value,
        checked: e.target.checked,
      })
    );
  };

  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor="white"
      headerProps={{ withBackButton: true, centerTitle: "알림설정" }}
    >
      <Wrapper>
        {NOTIFICATION_SETTINGS_OPTIONS.map((item) => {
          return (
            <Switch
              key={item.name}
              value={item.value}
              label={item.label}
              checked={item.checked}
              onChange={(e) => handleChange(e, item.name)}
            />
          );
        })}
      </Wrapper>
    </MainLayout>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 16px 20px;
`;

export default NotificationSettings;
